import { isEmpty } from 'lodash';

import { fileExtensionRegex } from 'utils/regexes';

export const buildFileName = ({ name, fileExtension, extension }) => {
  const extensionToUse = fileExtension || extension;
  if (isEmpty(extensionToUse)) {
    return name;
  }

  const [nameMatch, extensionMatch] = name.match(fileExtensionRegex) || [];

  if (nameMatch && extensionMatch) {
    return nameMatch.replace(`.${extensionMatch}`, extensionToUse);
  }

  return `${name}${extensionToUse}`;
};
